import React, { Component, createRef } from "react";
import imgemoji from '../../../../../images/tinyaddemoji.png';

const EMOJIS = [
  { id: "love", code: "0x2764, 0xFE0F", label: "Love" },
  { id: "adore", code: "0x1F60D", label: "Adore" },
  { id: "like", code: "0x1F44D", label: "Like" },
  { id: "clap", code: "0x1F44F", label: "Clap" },
  { id: "party", code: "0x1F389", label: "Party" },
  { id: "hundred", code: "0x1F4AF", label: "100" },
  { id: "wow", code: "0x1F929", label: "Wow" },
  { id: "celebrate", code: "0x1F64C", label: "Celebrate" },
  { id: "strong", code: "0x1F4AA", label: "Strong" },
  { id: "custom", code: "-1", emoji: imgemoji, label: "Smiley", isImage: true }
];

const styles = `
  @keyframes popupIn {
    0% { opacity: 0; transform: translateY(14px) scale(0.8); }
    65% { transform: translateY(-4px) scale(1.04); }
    100% { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes emojiIn {
    0% { opacity: 0; transform: translateY(10px) scale(0.4); }
    70% { transform: translateY(-4px) scale(1.2); }
    100% { opacity: 1; transform: translateY(0) scale(1); }
  }
  .emoji-btn:hover .emoji-icon, .emoji-btn:hover img {
    transform: scale(1.4) translateY(-5px);
    transition: transform 0.15s cubic-bezier(0.34,1.56,0.64,1);
  }
  .emoji-btn .emoji-icon, .emoji-btn img {
    transition: transform 0.12s ease;
    display: block;
    line-height: 1;
  }
  @keyframes triggerPop {
    0%   { transform: scale(1); }
    35%  { transform: scale(0.88); }
    65%  { transform: scale(1.12); }
    100% { transform: scale(1); }
  }
  .trigger-pop { animation: triggerPop 0.3s ease; }
`;

export default class EmojiReaction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      animKey: 0,
      triggerAnim: false
    };

    // Locks display to the default Custom Smiley configuration
    this.defaultTrigger = EMOJIS[9];

    this.wrapperRef = createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handlePick = this.handlePick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.open && !prevState.open) {
      document.addEventListener("mousedown", this.handleOutsideClick);
    } else if (!this.state.open && prevState.open) {
      document.removeEventListener("mousedown", this.handleOutsideClick);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    clearTimeout(this.animTimeout);
  }

  transformEmojiCodeToRender = (emoji) => {
    if (!emoji || emoji === "-1") return "";
    const hexArray = emoji.split(",");
    const codePoints = hexArray.map((hex) => parseInt(hex.trim(), 16));
    return String.fromCodePoint(...codePoints);
  };

  handleOutsideClick(e) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  handleTriggerClick() {
    this.setState((prevState) => ({
      open: !prevState.open,
      animKey: prevState.animKey + 1
    }));
  }

  handlePick(item) {
    this.setState({
      open: false,
      triggerAnim: false
    }, () => {
      if (item.isImage)
        return;

      if (this.props.onSelectEmoji) {
        let symbolOutput = "";
        if (item.isImage) {
          symbolOutput = "😊";
        } else {
          // Send over the standard symbol value string sequence
          symbolOutput = this.transformEmojiCodeToRender(item.code);
        }

        // Pass both the character symbol and the configuration raw code to the parent
        this.props.onSelectEmoji({
          symbol: symbolOutput,
          code: item.code
        });
      }

      requestAnimationFrame(() => {
        this.setState({ triggerAnim: true });
      });
      this.animTimeout = setTimeout(() => {
        this.setState({ triggerAnim: false });
      }, 350);
    });
  }

  renderEmojiMarkup(item) {
    if (item.isImage) {
      return (
        <img
          src={item.emoji}
          alt={item.label}
          style={{ width: 32, height: 32, objectFit: 'contain', display: 'block' }}
        />
      );
    }
    return (
      <span className="emoji-icon" style={{ fontSize: 32 }}>
        {this.transformEmojiCodeToRender(item.code)}
      </span>
    );
  }

  render() {
    const { open, animKey, triggerAnim } = this.state;

    return (
      <>
        <style>{styles}</style>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div ref={this.wrapperRef} style={{ position: "relative", display: "inline-block" }}>

            {open && (
              <div key={animKey}
                style={{
                  position: "absolute",
                  right: "50%",
                  background: '#515151',
                  border: "0.5px solid var(--color-border-secondary, #ccc)",
                  borderRadius: 40,
                  padding: "6px 12px",
                  margin: '18px',
                  display: "flex",
                  gap: 4,
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  animation: "popupIn 0.28s cubic-bezier(0.34,1.56,0.64,1) forwards",
                  zIndex: 10,
                  whiteSpace: "nowrap",
                }}>
                {EMOJIS.map((item, i) => (
                  <button
                    key={item.id}
                    className="emoji-btn"
                    onClick={() => this.handlePick(item)}
                    title={item.label}
                    style={item.label === "Smiley" ? { display: "none" } : {
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "4px 4px",
                      borderRadius: 10,
                      transition: "transform 0.15s ease",
                      animation: `emojiIn 0.3s cubic-bezier(0.34,1.56,0.64,1) ${i * 25}ms both`,
                    }}
                  >
                    {this.renderEmojiMarkup(item)}
                  </button>
                ))}
              </div>
            )}

            <button
              className={triggerAnim ? "trigger-pop" : ""}
              onClick={this.handleTriggerClick}
              title={this.defaultTrigger.label}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 4,
                fontSize: 24,
                lineHeight: 1,
                display: "block",
              }}
            >
              {this.renderEmojiMarkup(this.defaultTrigger)}
            </button>

          </div>
        </div>
      </>
    );
  }
}